import { FC, memo } from 'react';
import { Modal } from 'shared/ui/Modal';
import { Form } from 'features/Form';
import { OrderRequestDto } from 'shared/api';
import { ORDER_FORM_FIELDS } from '../../constants/orderConstants';

interface OrderFormProps {
  editingOrder: OrderRequestDto | null;
  isEditing: boolean;
  onSubmit: (data: OrderRequestDto) => void;
  onCancel: () => void;
}

export const OrderForm: FC<OrderFormProps> = memo(({
  editingOrder,
  isEditing,
  onSubmit,
  onCancel,
}) => (
  <Modal
    title={isEditing ? 'Редактировать заказ' : 'Создать заказ'}
    open
    onCancel={onCancel}
    footer={null}
    width={600}
  >
    <Form
      fields={ORDER_FORM_FIELDS}
      initialValues={editingOrder || {}}
      onSubmit={onSubmit}
    />
  </Modal>
));

OrderForm.displayName = 'OrderForm';
